<template>
  <div class="modal fade" id="jobCategoryModal" tabindex="-1" style="opacity: 1">
    <div class="modal-dialog modal-lg" style="margin-top: 5rem">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">職種を選択してください</h4>
          <button type="button" class="close" data-dismiss="modal"><span>×</span></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-4 col-12" v-for="item in largeData">
              <a href="javascript:;">
                <button
                  :ref="'large'+item.id"
                  type="button"
                  @click="largeClick(item.id)"
                  :class="{btn: true, 'btn-link': true, active: largeSelectedId === item.id}">
                  {{item.name}}
                </button>
              </a>
            </div>
          </div>
          <div class="m-t-lg vue-modal">
            <div v-for="middle in middleData" class="panel-group">
              <div class="panel panel-default" :class="['js-content-' + middle.root_parent_id]">
                <div class="panel-heading">
                  <h3 class="panel-title">
                      {{middle.name}}
                  </h3>
                </div>
                <div class="panel-body">
                  <div v-for="item in middle.children"
                          :class="{btn:true, 'btn-link': true, active: String(smallSelectedId) === String(item.id)}"
                          @mouseover="m_over(item.id)"
                          @mouseleave="m_out(item.id)"
                          @click="smallClick(item.id)">
                    <div :class="{
                      'm-xs': true,
                      'iradio_square-green': true,
                      'checked': String(smallSelectedId) === String(item.id),
                      'hover': String(mouseOverId) === String(item.id)}">
                    </div>
                    <span>{{item.name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal" @click="confirm">選択を確定する</button>
          <button type="button" class="btn btn-default" data-dismiss="modal">閉じる</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">

  const f = require('../lib/functions')
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
  import modal_mixin from '../mixins/modal'
  const DATA_NAME = 'job_category'


  export default {
    mixins: [modal_mixin],
    computed: {
      ...mapGetters([
        [DATA_NAME],
        [DATA_NAME+'_id']
      ]),
    },
    mounted: function(){
      const that = this
      $('#jobCategoryModal').on('show.bs.modal', function (e) {
        that.middleData = {}
        that.largeSelectedId = null
        that.smallSelectedId = that[DATA_NAME+'_id']
        that.setLargeSelected()
      })
    },
    watch: {
      [DATA_NAME]: function (value) {
        this.largeData = {...f.depth0(value)}
        this.setLargeSelected()
      }
    },
    data() {
      return {
        largeData: {},
        middleData: {},
        largeSelectedId: null,
        smallSelectedId: null,
        mouseOverId: null,
      }
    },
    methods: {
      confirm(){
        this.setValue({key: DATA_NAME + '_id', value: this.smallSelectedId})
      },
      smallClick(id) {
        if(this.smallSelectedId === id){
          this.smallSelectedId = ''
        }else{
          this.smallSelectedId = id
        }
      },
      largeClick(id) {
        this.largeSelectedId = id
        this.setMiddleData()
        this.slideToContent(id)
      },
      setLargeSelected() {
        if( this.smallSelectedId && this[DATA_NAME] ){
          this.largeClick(this[DATA_NAME][this.smallSelectedId].root_parent_id)
        }
      },
      setMiddleData() {
        this.middleData = {}
        if( this.largeSelectedId || this[DATA_NAME]){
          _.forEach(f.children(this[DATA_NAME], this.largeSelectedId), (middle) => {
            let withChildren = {
              [middle.id]: {
                ...middle,
                children: {...f.children(this[DATA_NAME], middle.id)}
              }
            }
            this.middleData = {
              ...this.middleData,
              ...withChildren
            }
          })
        }
      }
    },
  }
</script>
